// Página aberta pelo link do "Indique e ganhe" (myplanner.expo.app/baixar?i=CODIGO), antes de entrar na conta:
// mostra o código de quem indicou e os botões para baixar a versão mais recente do app ou usar no navegador.
import { useEffect, useState } from 'react';
import { Platform, Pressable, ScrollView, Text, View } from 'react-native';
import { guardarIndicacao } from '../lib/indicacao';
import { LOJA_ANDROID, LOJA_IOS } from '../lib/config';
import { C } from './theme';
import { Btn } from './ui';
import { t } from '../lib/i18n';


export function IndicacaoPublica({ codigo, onContinuar }: { codigo: string; onContinuar: () => void }) {
  const [copiado, setCopiado] = useState(false);
  useEffect(() => { if (codigo) guardarIndicacao(codigo); }, [codigo]);
  const ua = Platform.OS === 'web' && typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const iphone = /iphone|ipad/i.test(ua);
  const android = /android/i.test(ua);
  const copiar = () => { try { navigator.clipboard?.writeText(codigo).then(() => setCopiado(true), () => {}); } catch { /* sem cópia */ } };
  const cor = '#8B5CF6';
  return (
    <ScrollView style={{ flex: 1, backgroundColor: C.bg }} contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', padding: 28, gap: 14, width: '100%', maxWidth: 520, alignSelf: 'center' }}>
      <Text style={{ fontSize: 52, textAlign: 'center' }}>🎁</Text>
      <Text style={{ color: C.text, fontSize: 24, fontWeight: '800', textAlign: 'center' }}>{t('Você foi convidado para o My Planner')}</Text>
      <Text style={{ color: C.sub, textAlign: 'center' }}>{t('Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.')}</Text>
      {!!codigo && (
        <View style={{ backgroundColor: C.card, borderRadius: 16, padding: 16, gap: 8, alignItems: 'center' }}>
          <Text style={{ color: C.sub, fontSize: 12, textAlign: 'center' }}>{t('Código de quem convidou você')}</Text>
          <Text style={{ color: C.text, fontSize: 28, fontWeight: '800', letterSpacing: 4 }} selectable>{codigo}</Text>
          <Text style={{ color: C.sub, fontSize: 12, textAlign: 'center' }}>{t('Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.')}</Text>
          <Pressable onPress={copiar} style={{ paddingVertical: 6, paddingHorizontal: 14 }}>
            <Text style={{ color: cor, fontWeight: '700' }}>{copiado ? '✓ ' + t('Código copiado') : t('Copiar o código')}</Text>
          </Pressable>
        </View>
      )}
      {!iphone && <Btn cor={cor} label={'📲 ' + t('Baixar o app')} onPress={() => { window.location.href = LOJA_ANDROID; }} />}
      {iphone && <Btn cor={cor} label={'📲 ' + t('Baixar o app')} onPress={() => { window.location.href = LOJA_IOS; }} />}
      {(android || iphone) && !!codigo && <Pressable onPress={() => { window.location.href = `myplanner://baixar?i=${codigo}`; }} style={{ alignItems: 'center', padding: 6 }}>
        <Text style={{ color: C.sub, fontWeight: '600' }}>{t('Já tenho o app: abrir nele')}</Text></Pressable>}
      <Btn cor={cor} outline label={'🌐 ' + t('Usar no navegador (My Planner Web)')} onPress={onContinuar} />
    </ScrollView>
  );
}
